import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
// ------------------- Menu -----------------------
import BootstrapMenuBar from "components/menu/BootstrapMenuBar";
// ------------------- TS Expert -----------------------
import TSExpert from "components/ts-expert/TSExpert";
// ------------------- Protocol -----------------------
import ProtocolResume from "components/monitor/resume/Resume";
import ProtocolLiveList from "components/monitor/LiveList";
import ProtocolLiveListMatrix from "components/monitor/LiveListMatrix";
import ProtocolEventLog from "components/monitor/EventLog";
// ------------------- Analyzer DP -----------------------
import AnalyzerDNLiveList from "components/analyzer-dn/LiveList";
import AnalyzerDNLiveListMatrix from "components/analyzer-dn/LiveListMatrix";
import AnalyzerDNOscilloscope from "components/analyzer-dn/Oscilloscope";
// import AnalyzerDPOscilloscope2 from "components/analyzer-dn/Oscilloscope";
import AnalyzerDNBarGraph from "components/analyzer-dn/BarGraph";
import AnalyzerDNEventLog from "components/analyzer-dn/EventLog";
// ------------------ Configs -----------------------
import Configuration from "components/login-config/configuration/Configuration";
// ------------------ Login -----------------------
import Login from "components/login-config/login/Login";
import LoginHandler from "components/login-config/login/LoginHandler";
import Constants from "utilities/Constants";
// ------------------ Constants / Strings -----------------------

class App extends Component {

  componentDidMount() {
    if (localStorage.getItem(Constants.LOCAL_STORAGE_KEY) === null) {
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "language", { mode: "cors" })
        .then(response => response.json())
        .then(data => {
          localStorage.setItem(Constants.LOCAL_STORAGE_KEY, data.language || Constants.PT_LANG_KEY);
          window.location.reload();
        })
        .catch(() => {
          localStorage.setItem(Constants.LOCAL_STORAGE_KEY, Constants.PT_LANG_KEY);
          window.location.reload();
        });
    }
  }

  render() {
    return (
      <Router basename={process.env.PUBLIC_URL}>
        <div className="App">
          <BootstrapMenuBar />
          <div style={mainAppContentStyle}>
            {/* ------------------ TS Expert------------------ */}
            <Route exact path="/" component={TSExpert} />
            {/* ------------------ Protocol Routes------------------ */}
            <Route path="/protocol-resume" component={ProtocolResume} />
            <Route exact path="/protocol-livelist" component={ProtocolLiveList} />
            <Route exact path="/protocol-livelist/:address" component={ProtocolLiveList} />
            <Route path="/protocol-livelist-matrix" component={ProtocolLiveListMatrix} />
            <Route path="/protocol-log" component={ProtocolEventLog} />
            {/* ------------------ Physical Medium DP Routes------------------ */}
            <Route exact path="/dn-live-list" component={AnalyzerDNLiveList} />
            <Route path="/dn-live-list-matrix" component={AnalyzerDNLiveListMatrix} />
            <Route path="/dn-oscilloscope" component={AnalyzerDNOscilloscope} />
            {/* <Route path="/dn-oscilloscope2" component={AnalyzerDPOscilloscope2} /> */}
            <Route path="/dn-bar-graph" component={AnalyzerDNBarGraph} />
            <Route path="/dn-log" component={AnalyzerDNEventLog} />
            {/* ------------------ Config ------------------ */}
            <Route path="/config" component={Configuration} />
            {/* ------------------ Login ------------------ */}
            <Route path="/login" component={Login} />
            <Route path="/login-handler" component={LoginHandler} />
          </div>
        </div>
      </Router>
    );
  }
}

// CSS Custom App Margins
const mainAppContentStyle = {
  marginLeft: "24px",
  marginRight: "24px",
};

export default App;
